import { app } from '../../app.module'
// Line投稿平均データ
interface ILinePostAverageData {
  likes: number
  comments: number
  shares: number
  engagements: number
  engagementRates: number
}

/**
 * Line投稿テーブルの平均
 * @class PostLineTableAverageComponentCtrl
 */
class PostLineTableAverageComponentCtrl {
  // 平均データ
  private averageData: ILinePostAverageData
  // 平均データビュー
  private averageDataView: ILinePostAverageData
  // 投稿数
  private postsCount: number

  constructor() {
    this.averageDataView = {
      likes: 0,
      comments: 0,
      shares: 0,
      engagements: 0,
      engagementRates: 0,
    }
  }

  /**
   * 平均データが変更時、平均を算出
   */
  public $onChanges(): void {
    this.caculateAverage()
  }

  /**
   * 平均を算出
   * @private
   * @returns {void}
   */
  private caculateAverage(): void {
    this.averageDataView = {
      likes: 0,
      comments: 0,
      shares: 0,
      engagements: 0,
      engagementRates: 0,
    }
    if (this.postsCount === 0 || this.postsCount === undefined || this.postsCount === null) {
      return
    }

    this.averageDataView.likes = this.averageData.likes / this.postsCount
    this.averageDataView.comments = this.averageData.comments / this.postsCount
    this.averageDataView.shares = this.averageData.shares / this.postsCount
    this.averageDataView.engagements = this.averageData.engagements / this.postsCount
    this.averageDataView.engagementRates = this.averageData.engagementRates / this.postsCount
  }
}

app.component('postLineTableAverage', {
  bindings: {
    averageData: '<',
    postsCount: '<',
  },
  template: require('./post-line-table-average.pug')(),
  controller: PostLineTableAverageComponentCtrl,
})
